
cc.Class({
    extends: cc.Component,

    properties: {
        clickSounds: {
            type: cc.AudioClip,
            default: []
        }
    },

    onLoad () {
        this.audioManager = cc.find('AudioManager').getComponent('AudioManager');

        if (this.audioManager) {
            this.playSfx = this._playSfx;
        } else {
            // if there is no audio manager, provide a empty body function API
            this.playSfx = () =>{};
        }
    },

    _playSfx (soundIndex) {
        this.audioManager.playOneShot(this.clickSounds[soundIndex]);
    },

});
